import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import ctaTypes from '../../../../../enums/CTA.enums';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import { targetLinkdsk } from '../../../../../utils/targetDskLink';
import DownloadCTA from '../../../../@shared/downloadCTA';
import Icon from '../../../../@shared/icon';
import RoutableSitecoreLink from '../../../../@shared/routableSitecoreLink';
import breakpoints from '../../../../../constants/breakpoints.constants';
import { TCardButtonProps } from '../../../types/cardColumnLayout.types';
import CTA from '../../../../@shared/CTA';

const CardColumnButtons: FC<TCardButtonProps> = ({
  cta1,
  cta2,
  downloadButtonLink,
  primaryctaColor,
  secondaryctaColor,
  validcta2Exists,
  validDownloadExists,
  cta2Click,
  showPopupWithSplitModule,
  handleSplitModuleModal,
  splitModuleLabel,
}) => {
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  return (
    <div className={'card-column__buttons'}>
       {showPopupWithSplitModule ? (
        <CTA
          type={ctaTypes['brand-primary']}
          onClick={(): void => {
            handleSplitModuleModal && handleSplitModuleModal(true);
          }}
          extraClassName={`card-column__primary-cta card-column--${primaryctaColor}`}
        >
          {splitModuleLabel}
        </CTA>
      ) : cta1?.value?.text && cta1?.value?.href && (
        <RoutableSitecoreLink
          className={`card-column__primary-cta card-column--${primaryctaColor}`}
          field={cta1}
          target={targetLinkdsk(cta1, isDesktop)}
        />
      )}
      {(validcta2Exists || validDownloadExists ) && (
        <div className={`card-column__secondary-cta card-column--${secondaryctaColor}`}>
          {validcta2Exists && cta2 && (
            <div className={'cta-with-arrow'}>
              <RoutableSitecoreLink onClick={cta2Click} field={cta2} target={targetLinkdsk(cta2, isDesktop)}>
                {cta2?.value?.text}
                <span className="cta-with-arrow__text">
                  <Icon iconName="arrow-chevron-right" size={iconSize.dsk} color={'primary'} extraClassName="cta-with-arrow__icon" />
                </span>
              </RoutableSitecoreLink>
            </div>
          )}
          {!validcta2Exists && downloadButtonLink && (
            <DownloadCTA field={downloadButtonLink} type={ctaTypes['secondaryBlack']} extraClassName="card-column__download-cta" />
          )}
        </div>
      )}
    </div>
  );
};

export default CardColumnButtons;
